export const iconFontAwesomeAccessibilityEyeLowVision = (
	<i className="fa-solid fa-eye-low-vision"></i>
);
